const US_STATE_TO_ABBR = {
  alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA', colorado: 'CO', connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT', virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY', 'district of columbia': 'DC'
}

const OS_RULES = [
  { test: /windows nt/i, value: 'Windows' },
  { test: /mac os x/i, value: 'macOS', exclude: /iphone|ipad|ipod/i },
  { test: /iphone|ipad|ipod/i, value: 'iOS' },
  { test: /android/i, value: 'Android' },
  { test: /linux/i, value: 'Linux' }
]

const ARCH_RULES = [
  { test: /arm64|aarch64/i, value: 'arm64' },
  { test: /x86_64|win64|x64|amd64/i, value: 'x86_64' },
  { test: /i[3-6]86|x86/i, value: 'x86' }
]

export const formatLastLogin = (iso) => {
  const twelve = 12
  if (!iso) return '-'

  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '-'

  const day = String(date.getDate()).padStart(2, '0')
  const month = date.toLocaleString('en-GB', { month: 'short' }) // Jan
  const year = date.getFullYear()

  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const ampm = hours >= twelve ? 'PM' : 'AM'

  if (hours === 0) {
    hours = twelve
  } hours %= twelve

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`
}

export const formatApplication = (eventType) => {
  if (!eventType) return '-'
  // policy.evaluate_sign_on -> Policy Evaluate Sign On
  return eventType
    .split(/[._]/g)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

const normalizeBrowserName = (browser) => {
  if (!browser) return ''
  const b = String(browser).toLowerCase()
  if (b.includes('chrome')) return 'Chrome'
  if (b.includes('edge') || b.includes('edg')) return 'Edge'
  if (b.includes('firefox')) return 'Firefox'
  if (b.includes('safari')) return 'Safari'
  if (b.includes('opera') || b.includes('opr')) return 'Opera'
  return browser.charAt(0).toUpperCase() + browser.slice(1).toLowerCase()
}

const parseBrowser = (ua, fallbackBrowser) => {
  if (!ua) return { browserName: fallbackBrowser || '', browserVersion: '' }

  let m

  // Edge
  m = ua.match(/Edg\/([\d.]+)/i)
  if (m) return { browserName: 'Edge', browserVersion: m[1] }

  // Chrome / HeadlessChrome
  m = ua.match(/(?:HeadlessChrome|Chrome)\/([\d.]+)/i)
  if (m) return { browserName: 'Chrome', browserVersion: m[1] }

  // Firefox
  m = ua.match(/Firefox\/([\d.]+)/i)
  if (m) return { browserName: 'Firefox', browserVersion: m[1] }

  // Safari (Version/x.y + Safari)
  m = ua.match(/Version\/([\d.]+).*Safari/i)
  if (m) return { browserName: 'Safari', browserVersion: m[1] }

  return { browserName: fallbackBrowser || '', browserVersion: '' }
}

const normalizeOs = (os) => {
  const v = String(os).toLowerCase()
  if (v.includes('mac')) return 'macOS'
  if (v.includes('win')) return 'Windows'
  if (v.includes('ios')) return 'iOS'
  if (v.includes('android')) return 'Android'
  if (v.includes('linux')) return 'Linux'
  return os
}

const parseOsAndArch = (fallbackOs, ua = '') => {
  const osRule = OS_RULES.find(({ test, exclude }) =>
    test.test(ua) && !(exclude?.test(ua))
  )

  let osName
  if (osRule) {
    osName = osRule.value
  } else if (fallbackOs) {
    osName = normalizeOs(fallbackOs)
  } else {
    osName = ''
  }

  const archRule = ARCH_RULES.find(({ test }) => test.test(ua))

  let arch = ''
  if (archRule) {
    arch = archRule.value
  }

  return { osName, arch }
}

export const formatDeviceSystem = (item) => {
  if (!item) return '-'

  const ua = item.rawUserAgent || ''
  const fallbackBrowser = normalizeBrowserName(item.browser)

  const { browserName, browserVersion } = parseBrowser(ua, fallbackBrowser)
  const { osName, arch } = parseOsAndArch(ua, item.os)

  const browserPart = browserName && browserVersion ? `${browserName}, Version ${browserVersion}` : browserName || '-'

  const systemBits = [osName, arch].filter(Boolean).join(' ')
  return systemBits ? `${browserPart} (${systemBits})` : browserPart
}

const toStateAbbr = (state) => {
  if (!state) return ''
  const s = String(state).trim()
  if (!s) return ''

  if (/^[A-Za-z]{2}$/.test(s)) return s.toUpperCase()

  const key = s.toLowerCase()
  return US_STATE_TO_ABBR[key] || s
}

export const formatLocation = ({ city, state }) => {
  const c = city?.trim()
  const st = toStateAbbr(state)

  if (c && st) return `${c}, ${st}`
  if (c) return c
  if (st) return st
  return '-'
}
